import { Stack } from '@mui/material';
import { ASSESSMENT_COMMON } from 'utils/constants';

export function AdminHeader() {
  return (
    <Stack
      height="4rem"
      p="0.688rem 1rem"
      width="100%"
      justifyContent="left"
    >
      <img
        src={ASSESSMENT_COMMON.logoPath}
        alt={ASSESSMENT_COMMON.logoAlt}
        width="131px"
        height="42px"
      />
    </Stack>
  );
}
